let projects = [
    {
      key: 1,
      title: "Sunglass Hut",
      about: "It's a Sunglass selling site for influencing people to buy QualityFul Sunglass. Users can sign up/log in here and buy goods Sunglass from the site. I've implemented admin panel too.",
      technology: [
        {
          use: "React"
        },
        {
          use: "React-Bootstrap"
        },
        {
          use: "Material UI"
        },
        {
          use: "Firebase"
        },
        {
          use: "Nodejs"
        },
        {
          use: "Express"
        },
        {
          use: "MongoDB"
        }
      ],
      description: [
        {
          power: "Users can see the products which will be loaded from MongoDB."
        },
        {
          power: "Users can order any products and their data will be saved on the database."
        },
        {
          power: "Users need to create accounts via email, password, and google then can see their dashboard, individual orders in my order's section, and cancel any order too."
        },
        {
          power: "Admin can see all the orders of all users and can cancel or approve any order at any time."
        },
        {
          power: "Admin can add new products and admin can change user's role."
        },
        {
          power: "fully responsive for all devices."
        }
      ],
      img: [
        {
          images: "https://github.com/RomanSheikh99/Images/blob/main/projects/projects-1/sliderImg-1.png?raw=true"
        },
        {
          images: "https://github.com/RomanSheikh99/Images/blob/main/projects/projects-1/sliderImg-2.png?raw=true"
        },
        {
          images: "https://github.com/RomanSheikh99/Images/blob/main/projects/projects-1/sliderImg-3.png?raw=true"
        }
      ],
      git: [
        {
          link: "https://lato-sunglass.web.app/",
          codes: "Preview"
        },
        {
          link: "https://github.com/RomanSheikh99/sunglass-hut",
          codes: "Client Side Code"
        },
        {
          link: "https://github.com/RomanSheikh99/sunglass-hut-server",
          codes: "Server Side Code"
        }
      ]
  },
  // project 2 
    {
      key: 2,
      title: "Tarunno Travel Agency",
      about: "This site is about a Tour Package Booking System. We take all the responsibilities of our tourists and take order from this site.",
      technology: [
        {
          use: "React"
        },
        {
          use: "React-Bootstrap"
        },
        {
          use: "Firebase"
        },
        {
          use: "Nodejs"
        },
        {
          use: "Express"
        },
        {
          use: "MongoDB"
        }
      ],
      description: [
        {
          power: "Users can see the tour packages which will be loaded from MongoDB."
        },
        {
          power: "Users can order any package and their data will be saved on the database."
        },
        {
          power: "Users need to create accounts via google then can see their individual orders in myorder's section and cancel any order too."
        },
        {
          power: "Admin can see all the orders of all users and can cancel any order at any time."
        },
        {
          power: "Admin Add Tour Packages."
        }
      ],
      img: [
        {
          images: "https://github.com/RomanSheikh99/Images/blob/main/projects/project-2/sliderImg-1.png?raw=true"
        },
        {
          images: "https://github.com/RomanSheikh99/Images/blob/main/projects/project-2/sliderImg-2.png?raw=true"
        },
        {
          images: "https://github.com/RomanSheikh99/Images/blob/main/projects/project-2/sliderImg-3.png?raw=true"
        }
      ],
      git: [
        {
          link: "https://tarunno-travel-agency.web.app/",
          codes: "Preview"
        },
        {
          link: "https://github.com/RomanSheikh99/tarunno-travel",
          codes: "Client Side Code"
        },
        {
          link: "https://github.com/RomanSheikh99/tarunno-travel-server",
          codes: "Server Side Code"
        }
      ]
    },
    {
      key: 3,
      title: "Tarunno Travel Agency",
      about: "It's a hospital related website.You can register a new user from the register page using custom email and password and will take medical services",
      technology: [
        {
          use: "HTML"
        },
        {
          use: "CSS"
        },
        {
          use: "JavaScript"
        },
        {
          use: "REACT BOOTSTRAP"
        },
        {
          use: "REACT"
        },
        {
          use: "Firebase"
        }
      ],
      description: [
        {
          power: "You can register a new user from the register page using custom email and password"
        },
        {
          power: "If you Logged in you can see the details about the services and doctors"
        },
        {
          power: "Or If you Don't Logged in it will Redirect you to Register page"
        },
        {
          power: "After login you can see your name or your email address in navbar"
        },
        {
          power: "This is fully responsive site."
        }
      ],
      img: [
        {
          images: "https://github.com/RomanSheikh99/Images/blob/main/projects/project-3/sliderImg-1.png?raw=true"
        },
        {
          images: "https://github.com/RomanSheikh99/Images/blob/main/projects/project-3/sliderImg-2.png?raw=true"
        },
        {
          images: "https://github.com/RomanSheikh99/Images/blob/main/projects/project-3/sliderImg-3.png?raw=true"
        }
      ],
      git: [
        {
          link: "https://diptohospital.web.app/",
          codes: "Preview"
        },
        {
          link: "https://github.com/RomanSheikh99/dipto-hospital",
          codes: "View Code"
        }
      ]
    },
    {
      key: 4,
      title: "Instru Music Classes",
      about: "instrument tech website.Here you can learn to play many types of instruments.",
      technology: [
        {
          use: "HTML"
        },
        {
          use: "CSS"
        },
        {
          use: "BOOTSTRAP"
        },
        {
          use: "React"
        },
        {
          use: "React Route"
        },
        {
          use: "NETLIFY"
        }
      ],
      description: [
        {
          power: "I used React and React Bootstrap to design this site."
        },
        {
          power: "This Website has Route system."
        },
        {
          power: "This website will take you to the page where you click on the route of Nebvar"
        },
        {
          power: "Or you put any wrong path name in url port it will take you to Not Found page."
        }
      ],
      img: [
        {
          images: "https://github.com/RomanSheikh99/Images/blob/main/projects/project-4/sliderImg-1.png?raw=true"
        },
        {
          images: "https://github.com/RomanSheikh99/Images/blob/main/projects/project-4/sliderImg-2.png?raw=true"
        },
        {
          images: "https://github.com/RomanSheikh99/Images/blob/main/projects/project-4/sliderImg-3.png?raw=true"
        }
      ],
      git: [
        {
          link: "https://instrumusic.netlify.app/",
          codes: "Preview"
        },
        {
          link: "https://github.com/RomanSheikh99/Instru-Music-Classes",
          codes: "View Code"
        }
      ]
    }
]
  


export default projects;